/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const INTRO_SCREEN = 'intro';
export const TRAILER_SCREEN = 'trailer';
export const PLAYLIST_SCREEN = 'playlist';
export const SCENE_SCREEN = 'scene';
export const SELECTION_SCREEN = 'selection';
